export default "__VITE_ASSET__b47820fa__"